import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 50
    }
  }
};
export function ReviewsSection() {
  const reviews = [{
    title: 'Mi asistente personal',
    quote: 'Pensé que sabía usar la IA, pero los prompts de esta guía son de otro nivel. Organicé mi mes de contenidos para Instagram en una tarde. Es como tener un consultor sentado al lado mío.',
    author: 'Daniela V., Agency Owner'
  }, {
    title: 'Adiós al bloqueo mental',
    quote: 'Lo mejor es el Capítulo de Trabajo. Las propuestas que antes me tomaban toda la mañana ahora están listas antes de que termine mi café. Si valoras tu tiempo, esto es obligatorio.',
    author: 'Oscar L., Consultor Senior'
  }, {
    title: 'Sencillo y directo al grano',
    quote: 'Sin paja. Copias, pegas y funciona. Mi vida personal y mis comidas están en orden por primera vez en años. Gracias por hacerlo tan simple.',
    author: 'Mariana K., Madre y Profesional'
  }];
  return <section className="py-24 px-6 bg-[#0A0A0A] relative border-t border-[#D4AF37]/10" data-id="element-413">
      <div className="max-w-7xl mx-auto" data-id="element-414">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-415">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#E8E0D0] mb-4" data-id="element-416">
            ⭐ Lo que dicen los que ya recuperaron su tiempo
          </h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto rounded-full" data-id="element-417"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-418">
          {reviews.map((review, i) => <motion.div key={i} variants={cardVariants} className="bg-[#111111] border border-[#D4AF37]/30 rounded-xl p-8 shadow-[0_0_30px_rgba(212,175,55,0.05)] flex flex-col h-full relative overflow-hidden group hover:shadow-[0_0_40px_rgba(212,175,55,0.15)] hover:border-[#D4AF37]/60 transition-all duration-300" data-id="element-419">
              {/* Subtle background glow on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#D4AF37]/0 to-[#D4AF37]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-420"></div>

              <div className="flex text-[#D4AF37] mb-6" data-id="element-421">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-422" />)}
              </div>

              <h3 className="text-xl font-serif font-bold mb-4 text-[#D4AF37]" data-id="element-423">
                "{review.title}"
              </h3>

              <p className="text-[#E8E0D0] leading-relaxed mb-8 flex-grow italic" data-id="element-424">
                "{review.quote}"
              </p>

              <div className="mt-auto" data-id="element-425">
                <p className="text-[#A09880] font-semibold uppercase tracking-wide text-sm" data-id="element-426">
                  — {review.author}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}